import type { TFunction } from 'i18next';

export interface SetupShippingRateDraft {
  /** DB id when this draft maps to a persisted rate; absent for a freshly added (unsaved) draft. */
  id?: string;
  shippingRateName: string;
  /** Optional logo shown next to the rate at checkout — uploaded image URL, '' when none. */
  icon: string;
  isFree: boolean;
  priceMajor: string;
  allCountries: boolean;
  countryCodes: string[];
  /**
   * Carried through the wizard untouched — pickup points are configured in Stores > Shippings, not
   * here. The update payload is not partial, so the persisted value has to round-trip: hardcoding
   * `false` cleared the merchant's pickup-point rate on any unrelated edit (#TAG-1779).
   */
  isPickupPoint: boolean;
}

export function createDefaultSetupShippingRates(t: TFunction<'setup'>): { rates: SetupShippingRateDraft[] } {
  return {
    rates: [
      {
        shippingRateName: t('experience.shipping.defaultFreeName'),
        icon: '',
        isFree: true,
        priceMajor: '',
        allCountries: true,
        countryCodes: [],
        isPickupPoint: false,
      },
    ],
  };
}

export function createEmptySetupShippingRateDraft(): SetupShippingRateDraft {
  return {
    shippingRateName: '',
    icon: '',
    isFree: false,
    priceMajor: '',
    allCountries: true,
    countryCodes: [],
    isPickupPoint: false,
  };
}
